import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  List,
  ListIcon,
  ListItem,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { useStore } from "@nanostores/react";
import { userProfile } from "contexts/userProfile.js";

const options = [
  { id: 1, desc: "E-signatures per month: 50" },
  { id: 2, desc: "Document Insights: Basic" },
  { id: 3, desc: "Email Support" },
];

const options2 = [
  { id: 1, desc: "E-signatures per month: 150" },
  { id: 2, desc: "Document Insights: Advanced" },
  { id: 3, desc: "Document Storage: 500 MB" },
];
const options3 = [
  { id: 1, desc: "E-signatures per month: 500" },
  { id: 2, desc: "Document Insights: Advanced" },
  { id: 3, desc: "Document Storage: 10 GB" },
  { id: 4, desc: "24/7 Priority Support" },
  { id: 5, desc: "Custom Workflow Configuration" },
];

const PackageTier = ({ title, options, typePlan, checked = false }) => {
  const { auth } = useStore(userProfile);
  const history = useHistory();
  const colorTextLight = checked ? "white" : "purple.600";
  const bgColorLight = checked ? "purple.400" : "gray.300";

  const colorTextDark = checked ? "white" : "purple.500";
  const bgColorDark = checked ? "purple.400" : "gray.300";

  return (
    <Flex
      p={5}
      flexDirection={{ base: "column", md: "row" }}
      justifyContent="space-between"
      alignItems="center"
      bg={checked ? "purple.100" : "transparent"}
      borderRadius="lg"
    >
      <Heading size={"md"} flex="1">
        {title}
      </Heading>
      <List spacing={3} styleType="none" ml={0} flex="2">
        {options.map((desc) => (
          <ListItem key={desc.id}>
            <ListIcon as={FaCheckCircle} color="green.500" />
            {desc.desc}
          </ListItem>
        ))}
      </List>
      <Flex flex="1" flexDirection="column" alignItems="center" justifyContent="center">
        <Heading size={"xl"} flex="1" justifyContent="center">
          {typePlan}
        </Heading>
      </Flex>
      <Flex flex="1" flexDirection="column" alignItems="center" justifyContent="center">
        <Box flex="1" textAlign="right">
          <Button
            size="md"
            color={useColorModeValue(colorTextLight, colorTextDark)}
            bg={useColorModeValue(bgColorLight, bgColorDark)}
            // 3. Add onClick handler to button
            onClick={() => {
              history.push(auth ? "/admin/dashboard" : "/auth/sign-in");
            }}
          >
            Get Started
          </Button>
        </Box>
      </Flex>
    </Flex>
  );
};

const Pricing = () => {
  return (
    <Box py={12} px={5} width="full">
      <Stack spacing={4} width={"100%"} direction={"column"}>
        <Flex
          p={5}
          flexDirection={{ base: "column", md: "row" }}
          justifyContent="center"
          alignItems="center"
        >
          <Heading size={"lg"} textAlign="center" mb={{ base: 5, md: 0 }}>
            The Right Plan for
            <Text display="inline" color="purple.500">
              {" "}
              Your Business
            </Text>
          </Heading>
        </Flex>
        <Divider />
        <PackageTier title={"Starter"} typePlan="Free" options={options} />
        <Divider />
        <PackageTier title={"Professional"} checked={true} typePlan="$32.00" options={options2} />
        <Divider />
        <PackageTier title={"Enterprise"} typePlan="$50.00*" options={options3} />
      </Stack>
    </Box>
  );
};

export default Pricing;
